import { render, staticRenderFns } from "./ModalTecnicoAccept.vue?vue&type=template&id=4600d2f2"
import script from "./ModalTecnicoAccept.vue?vue&type=script&lang=js"
export * from "./ModalTecnicoAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports